import { computeWorkflowProgress } from 'features/libra/helpers/getWorkflowPercComplete'
import type { LibraTicket } from 'features/libra/ticket/libraTicketsApi'
import type { LibraWorkflow } from 'features/libra/workflow/workflowStepsApi'

export enum AssetStatus {
  NotStarted = 'not-started',
  InProgress = 'in-progress',
  Completed = 'completed',
}

/**
 * Calculates the status of an asset based on its tickets. Delegates per-ticket
 * progress + status to `computeWorkflowProgress`.
 */
export function getAssetStatus(
  unitTickets: ReadonlyArray<LibraTicket>,
  workflowMap: Map<string, LibraWorkflow>
): AssetStatus {
  const hasInProgress = unitTickets.some((ticket) => {
    if (ticket.workflowComplete) return false
    const workflow = workflowMap.get(ticket.workflowId)
    if (!workflow) return false
    return computeWorkflowProgress(ticket, workflow).status === 'in-progress'
  })
  if (hasInProgress) {
    return AssetStatus.InProgress
  }

  if (unitTickets.some((ticket) => ticket.workflowComplete)) {
    return AssetStatus.Completed
  }

  return AssetStatus.NotStarted
}
